import { handleRoute } from "../../../../../infrastructure/https";
import authClient from "../../../../../app/auth/Auth";
import Company from "../../../../domain/common/entities/Company";

export async function getCompany(): Promise<Company> {
  const companyId = await authClient.getCompanyId();
  const { data } = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}`,
  });
  return new Company({
    id: data.id,
    name: data.companyName,
    countryIsoCode: data.countryISO2Code,
  });
}
